var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { api } from 'helpers/Api';
import { computed, observable, action } from 'mobx';
import Storage from 'helpers/Storage';
export default class default_1 {
    // tickets = observable([])
    constructor(store) {
        this.tickets = [];
        this.collaboratorTickets = [];
        // console.log('CashDeskTicketStore - constructor')
        this.store = store;
        this.user_id = this.store.users.user.id;
        this._busy = { busy: false };
        const caja = this.getCaja();
        this.tickets = caja ? caja.tickets : [];
        // console.log('this._busy.busy', this._busy.busy)
    }
    sendTicketCashDesk(ticketCashDesk) {
        return api.post('ticketCashdesk', ticketCashDesk);
    }
    setBusy(busy) {
        this._busy.busy = busy;
    }
    get busy() {
        return this._busy.busy;
    }
    setTicket(ticket) {
        this.tickets.unshift(ticket);
    }
    setCollaboratorTicket(ticket) {
        this.collaboratorTickets.unshift(ticket);
    }
    /**
     * Abre caja
     */
    open() {
        return __awaiter(this, void 0, void 0, function* () {
            console.log('CashDeskTicketStore - open - id: ', this.user_id);
            let caja = this.getCaja();
            if (!caja) { // No ha abierto caja
                caja = { tickets: [], dateOpen: new Date(), importes: 0 };
                this.store.UI.newWarning('Caja abierta');
                Storage.set(this.user_id.toString(), caja);
            }
            else {
                if (!caja.tickets || !caja.dateOpen) {
                    if (!caja.tickets) {
                        caja.tickets = [];
                    }
                    if (!caja.dateOpen) {
                        caja.dateOpen = new Date();
                    }
                    Storage.set(this.user_id.toString(), caja);
                }
                if (caja.ids && caja.ids.length > 0) { // ticketsRecuperados = tickets de versión anterior(bgticket.ml), que estan en ids
                    const tickets = yield this.store.reports.readTicketsUser(this.user_id);
                    const ticketsRecuperados = tickets.filter(value => {
                        return caja.ids && caja.ids.includes(value.id);
                    });
                    console.log('CashDeskTicketStore - open - cantidad de ticketsRecuperados', ticketsRecuperados.length);
                    let importes = 0;
                    let dateMenor = new Date();
                    tickets.forEach(value => {
                        importes = importes + value.total;
                        if (value.datecheck < dateMenor) {
                            dateMenor = value.datecheck;
                        }
                    });
                    caja.tickets = ticketsRecuperados;
                    caja.dateOpen = dateMenor;
                    this.setTicket(ticketsRecuperados);
                }
                this.store.UI.newWarning('Caja abierta de nuevo');
            }
        });
    }
    isOpen() {
        return (this.getCaja()) !== null;
    }
    close() {
        Storage.remove((this.user_id.toString()));
    }
    /**
     * Añade un ticket
     * @param ticket
     */
    addTicket(ticket) {
        const caja = this.getCaja();
        // Doy por hecho que el id está, ya que se ha logeado y creado estructura en caso de ser la
        // primera vez
        if (!caja.tickets) {
            // No se ha creado la lista aún, no debe ser así porque en login se crea, pero por si las moscas
            caja.tickets = [];
        }
        caja.tickets.unshift(ticket);
        this.setTicket(ticket);
        Storage.set(String(this.user_id), JSON.stringify(caja));
    }
    addCollaboratorTicketToCashDesk(ticket) {
        return __awaiter(this, void 0, void 0, function* () {
            const caja = this.getCaja();
            console.log('caja: ', caja);
            if (!caja.collaboratorTickets) {
                caja.collaboratorTickets = [];
            }
            caja.collaboratorTickets.unshift(ticket);
            this.setCollaboratorTicket(ticket);
            Storage.set(String(this.user_id), JSON.stringify(caja));
        });
    }
    /*addTicketList(lista: Ticket[]) {
      const caja = this.getCaja()
      const cajaTickets = caja.tickets
      for (let i = 1; i < lista.length; i++) {
        cajaTickets.push(lista[i])
      }
      caja.tickets = cajaTickets
      Storage.set(String(this.user_id), JSON.stringify(caja)) // Comentado
    }*/
    getTicketsNotSend() {
        const caja = this.getCaja();
        if (caja.tickets) {
            const tickets = caja.tickets;
            const ticketsNotSend = tickets.filter((value) => value.id === undefined);
            // console.log('ticketsNotSend', ticketsNotSend.length)
            return ticketsNotSend;
        }
        return [];
    }
    cambiaTicketsNotSendToSend(tickets, refund) {
        console.log('CashDeskTicktStore - cambiaTicktsNotSendToSend - tickets', tickets);
        if (!tickets) {
            return;
        }
        this.setBusy(true);
        const caja = this.getCaja();
        if (caja.tickets) {
            for (let i = 0; i < caja.tickets.length; i++) {
                for (let j = 0; j < tickets.length; j++) {
                    if (tickets[j].numero === caja.tickets[i].numero) {
                        caja.tickets[i].id = tickets[j].id;
                        if (refund)
                            caja.tickets[i].daterefund = tickets[j].daterefund;
                    }
                    else {
                        /*console.log('else -- caja.tickets[i].numero', (caja.tickets[i] as Ticket).numero)
                        console.log('else -- tickets[j].numero', (tickets[j].numero))*/
                    }
                }
            }
            Storage.set(String(this.user_id), JSON.stringify(caja)); // Comentado
        }
        else {
            console.log('CashDeskTicktStore - cambiaTicketsNotSendToSend - else');
        }
        this.setBusy(false);
    }
    cambiaTicketNotSendToSend(ticket, refund) {
        const caja = this.getCaja();
        if (caja.tickets) {
            this.setBusy(true);
            for (let i = 0; i < caja.tickets.length; i++) {
                if (ticket.numero === caja.tickets[i].numero) {
                    caja.tickets[i].id = ticket.id;
                    if (refund)
                        caja.tickets[i].daterefund = ticket.daterefund;
                }
                else {
                    /*console.log('else -- caja.tickets[i].numero', (caja.tickets[i] as Ticket).numero)
                    console.log('else -- tickets[j].numero', (tickets[j].numero))*/
                }
            }
            Storage.set(String(this.user_id), JSON.stringify(caja)); // Comentado
            this.setBusy(false);
        }
        else {
            console.log('CashDeskTicktStore - cambiaTicketNotSendToSend - else');
        }
    }
    actualizarRefundedTicket(ticket) {
        try {
            this.setBusy(true);
            const caja = this.getCaja();
            if (caja.tickets) {
                for (let i = 0; i < caja.tickets.length; i++) {
                    if (ticket.numero === caja.tickets[i].numero) {
                        caja.tickets[i] = ticket;
                        caja.importes = caja.importes - ticket.total;
                        console.log('CashDeskTicketStore - refundTicket - actualizado');
                    }
                }
                Storage.set(String(this.user_id), JSON.stringify(caja)); // Comentado
            }
        }
        catch (e) {
            console.log('CashDeskTicketStore - refundTicket - catch');
            this.store.UI.newError('Se ha producido un error, contacte con el administrador del sistema, code: 1002');
        }
        this.setBusy(false);
    }
    sendTickets(tickets) {
        this.setBusy(true);
        return api.post('tickets/list', tickets)
            .then(value => {
            console.log('CashDeskTicketStore - tickets', value);
            this.setBusy(false);
            return value;
        })
            .catch(error => {
            console.log('CashDeskTicketStore - error');
            throw new Error(error);
        });
    }
    /**
     * return los tickets
     */
    getTickets() {
        this.setBusy(true);
        const caja = this.getCaja();
        this.setBusy(false);
        return caja.tickets || [];
    }
    getTicketByNumero(numero) {
        const caja = this.getCaja();
        const tickets = caja.tickets || [];
        let ticket;
        for (let i = 0; i < tickets.length; i++) {
            if (tickets[i].numero === numero) {
                ticket = tickets[i];
                break;
            }
        }
        console.log('CashDeskTicketStore - getTicketByNumero - ticket: ', ticket);
        return ticket;
    }
    getCaja() {
        return JSON.parse(Storage.get(this.user_id.toString()));
    }
}
__decorate([
    observable
], default_1.prototype, "_busy", void 0);
__decorate([
    observable
], default_1.prototype, "tickets", void 0);
__decorate([
    observable
], default_1.prototype, "collaboratorTickets", void 0);
__decorate([
    action
], default_1.prototype, "setBusy", null);
__decorate([
    computed
], default_1.prototype, "busy", null);
__decorate([
    action
], default_1.prototype, "setTicket", null);
__decorate([
    action
], default_1.prototype, "setCollaboratorTicket", null);



//////////////////
// WEBPACK FOOTER
// ./src/modules/TempSale/CashDeskTicketStore.ts
// module id = 354
// module chunks = 0